import { UnreachableCaseError } from "libs/errors";
import { getPointer, TagSubscriptionPreference } from "libs/schema";
import { toast } from "~/environment/toast-service";
import { withActionContext, write } from "./write";
import * as actions from "libs/actions";

export const updateTagSubscription = withActionContext(
  async (
    context,
    environment,
    props: {
      tagId: string;
      preference: TagSubscriptionPreference;
    },
  ) => {
    const { currentUserId } = context;
    const ownerOrganizationId = environment.auth.getAndAssertCurrentUserOwnerOrganizationId();

    const tagSubscriptionPointer = getPointer("tag_subscription", {
      tag_id: props.tagId,
      user_id: currentUserId,
    });

    const [originalTagSubscription] = await context.environment.loader.getRecord(tagSubscriptionPointer);

    return {
      forward: async () => {
        const action = await actions.updateTagSubscription.updateTagSubscription.action(
          {
            ...props,
            ownerOrganizationId,
          },
          context,
        );

        await write(environment, {
          action,
          onOptimisticWrite: () => {
            showToastForTagSubscriptionChange(props.preference);
          },
        });
      },
      backward: async () => {
        let action: actions.Action<unknown>;

        if (originalTagSubscription) {
          action = await actions.updateTagSubscription.updateTagSubscription.action(
            {
              tagId: props.tagId,
              preference: originalTagSubscription.preference,
              ownerOrganizationId,
            },
            context,
          );
        } else {
          action = await actions.updateTagSubscription.deleteTagSubscription.action(
            {
              tagId: props.tagId,
            },
            context,
          );
        }

        await write(environment, {
          action,
          onOptimisticWrite: () => {
            toast("vanilla", { subject: "Undoing tag subscription update." });
          },
        });
      },
    };
  },
);

function showToastForTagSubscriptionChange(preference: TagSubscriptionPreference) {
  switch (preference) {
    case "all": {
      toast("vanilla", {
        subject: `Subscribed to All.`,
        description: `
          You will receive a notification for every message
          in this channel.
        `,
      });
      break;
    }
    case "all-new": {
      toast("vanilla", {
        subject: `Subscribed.`,
        description: `
          You will receive a notification for every new
          thread created in this channel.
        `,
      });
      break;
    }
    case "involved": {
      toast("vanilla", {
        subject: `Unsubscribed.`,
        description: `
          You will only receive notifications for
          threads you are participating or @mentioned in.
        `,
      });
      break;
    }
    default: {
      throw new UnreachableCaseError(preference);
    }
  }
}
